import { datadogLogs } from "@datadog/browser-logs"
import { datadogRum } from "@datadog/browser-rum"

import { env } from "@/config/env"

export function initDatadog() {
  if (import.meta.env.DEV) return

  const { applicationId, clientToken, site, service, environment, version } =
    env.datadog

  if (!applicationId || !clientToken) return

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service,
    env: environment,
    version: version || undefined,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
  })

  datadogLogs.init({
    clientToken,
    site,
    service,
    env: environment,
    version: version || undefined,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error", "warn"],
    sessionSampleRate: 100,
  })
}
